<template>
    <v-container class="ufv-container-pages d-flex flex-column pt-0">
        <div class="ufv-container-text">
            <div class="text-h4">Área Administrativa: {{ contexto.sigla }}</div>
        </div>
        <div
            v-if="loading"
            class="my-8 align-self-stretch d-flex align-center justify-center"
        >
            <spinner />
        </div>
        <div
            v-if="!loading"
            class="my-6 flex-grow-1"
            style="border: 0px solid red"
        >
            <controles
                :filtroInicial="filtrosTexto"
                :lancadas="filtroLancado"
                @lancadaEscolhido="escolherLancado"
                @textoBusca="atualizarFiltroTexto"
            />
            <h2 class="ma-8 text-center" v-if="arvores.length === 0">
                Ainda não há nenhuma árvore cadastrada
            </h2>
            <lista-arvores
                v-if="arvores.length > 0"
                :arvores="arvoresFiltradas"
                @orderDown="orderDown"
                @orderUp="orderUp"
            />
        </div>
    </v-container>
</template>

<script>
import Spinner from "../../../componentes/ui/Spinner";
import Controles from "./Controles.vue";
import ListaArvores from "./ListaArvores.vue";
import {
    getServicoArvoresInstance,
    getServicoContexto,
} from "../../../services/ServicosFactory";
import Utils from "../../../utils/Utils";

const servicoArvores = getServicoArvoresInstance();
const servicoContexto = getServicoContexto();

const mapaFiltrosLancadas = {
    Todas: () => true,
    Desabilitadas: (arvore) => !arvore.habilitada,
    Lançadas: (arvore) => arvore.habilitada,
};

export default {
    components: { Spinner, Controles, "lista-arvores": ListaArvores },
    name: "ContextoAdmin",
    props: {
        id: { required: true },
    },
    data() {
        return {
            loading: true,
            filtroLancado: "Todas",
            filtrosTexto: "",
            arvores: [],
            contexto: {},
        };
    },
    computed: {
        arvoresFiltradas: function () {
            return this.arvores
                .filter(mapaFiltrosLancadas[this.filtroLancado])
                .filter(this.filtrarPorTexto);
        },
    },
    methods: {
        escolherLancado(escolha) {
            this.filtroLancado = escolha;
        },
        atualizarFiltroTexto(texto) {
            this.filtrosTexto = texto;
        },
        filtrarPorTexto(arvore) {
            const filtros = this.filtrosTexto.toLowerCase().split(" ");
            return filtros.every((filtro) => {
                return (
                    arvore.nome.toLowerCase().includes(filtro) ||
                    arvore.autor.toLowerCase().includes(filtro)
                );
            });
        },
        reloadArvores() {
            this.loading = true;
            servicoArvores
                .obterArvores({ idContexto: this.id })
                .then((arvores) => {
                    this.arvores = arvores;
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.$router.push(Utils.errorToRoute(error));
                });
        },
        orderDown(id) {
            servicoArvores.orderDown(id).then(() => {
                this.reloadArvores();
            });
        },
        orderUp(id) {
            servicoArvores.orderUp(id).then(() => {
                this.reloadArvores();
            });
        },
    },
    async mounted() {
        this.contexto = await servicoContexto.obterContexto(this.id);
        this.reloadArvores();
    },
};
</script>
